const register = {
  email: {
    error: "Please enter valid email",
  },
  username: {
    error: "Username cannot contain special characters",
  },
};

const validateEmail = (email) => {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email);
};

const validatePhone = (phone) => {
  const pattern = /^(\+62|62)?[\s-]?0?8[1-9]{1}\d{1}[\s-]?\d{4}[\s-]?\d{2,5}$/;
  return pattern.test(phone);
};

const validateDataCard = (data) => {
  if (
    data.card_name == "" ||
    data.slug == "" ||
    data.first_name == "" ||
    data.last_name == "" ||
    data.job_title == ""
  ) {
    return "Please complete mandatory field";
  }
  return "";
};

const validateDataBackground = (data) => {
  if (
    data.name == "" ||
    data.qr_position == "" ||
    data.image_id == "" ||
    data.qr_style == ""
  ) {
    return "Please complete mandatory field";
  }
  return "";
};

const validateDataContact = (data) => {
  if (
    data.first_name == "" ||
    data.last_name == "" ||
    data.contact_social.filter(
      (val, ind) => val.lookup_id == "LKP3cb4c0867b0f4a479b35b5bea1328fc3",
    ).length == 0
  ) {
    return "Please complete mandatory field";
  }
  return "";
};

const validateDataSignature = (data) => {
  if (data.card_id == "" || data.name == "" || data.template_id == "") {
    return "Please complete mandatory field";
  }
  return "";
};

export {
  register,
  validateDataCard,
  validateEmail,
  validatePhone,
  validateDataBackground,
  validateDataSignature,
  validateDataContact,
};
